/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  notes: 'Anteckningar',
  note: 'Anteckning',
  saved: 'Sparad',
  pin: 'Fäst',
  unpin: 'Lossa',
  unpinFailure: 'Anteckningen kunde inte lossas.',
  download: 'Ladda ned',
  share: 'Dela',
  shareSuccess: 'Anteckningen har delats.',
  shareFailure: 'Anteckningen kunde inte delas.',
  delete: 'Radera',
  deletePrompt: 'Är du säker på att du vill radera anteckningen?',
  search: 'Sök',
  syncFailure: 'Anteckningar kunde inte synkas.',
  filter: 'Filter',
  keyword: 'Nyckelord',
  newNote: 'Ny anteckning',
  add: 'Lägg till',
  created: 'Skapad',
  modified: 'Ändrad',
  selectNote: 'Välj en anteckning',
  selectNoteInformation: 'Panelen kommer att visa användbar information och alternativ när du valt en anteckning från listan.',
  welcome: 'Välkommen!',
  selectNoteOrCreate: 'Välj en anteckning eller skapa en ny.',
  conflict: 'Konflikt',
  syncingGotDisabled: 'Synkningen av anteckningen har stängts av pga oväntade fel.',
  notFoundOrNotSynced: 'Anteckningen kunde inte hittas eller har inte synkats än.',
}
